(function () {
    'use strict';

    angular.module('ib-MmB-booking-management-module', [
        'ib-passenger-management-module',
        'ib-travel-addons-module'
    ]);
})();